<template>
  <div class="upload_list">
    <p
      :class="`upload_list_title${
        documentType.required ? ' upload_list_title_required' : ''
      }`"
    >
      {{ title }}
    </p>
    <div class="upload_list_tips">
      {{ documentType[`description${$t("message.lan")}`] }}
      <br />
      {{
        $t("hzmbChange.message.upload_support_tips", [
          documentType.fileExtensions,
          documentType.maxFileSize,
        ])
      }}
    </div>
    <div class="upload_list_file">
      <div style="flex: 1">
        <div class="upload_filename">
          <span class="upload_list_file_text">{{
            $t("hzmbChange.message.already_upload_file")
          }}</span>
          <span class="upload_list_fileName"
            >{{ fileList.map((item) => item.name).join(", ") }}
            <span v-if="fileList.length > 0"
              >({{ fileList.map((item) => item.size).join() | formatFS }})</span
            ></span
          >
        </div>
      </div>
      <div class="pub_btn">
        <el-button
          v-if="fileList.length > 0"
          class="view_sample_danger"
          type="danger"
          plain
          @click="removeFile"
          >{{ $t("message.delete") }}</el-button
        >
        <el-button
          v-if="
            documentType.changeDocumentConfig &&
            documentType.changeDocumentConfig.dynamicDownloadDocument
          "
          class="view_sample_danger"
          type="danger"
          plain
          :loading="downloadLoading"
          @click="downloadDynamic"
          >{{ $t("hzmbChange.action.downloadDynamic") }}</el-button
        >
        <el-button
          v-if="documentType.sample"
          class="view_sample"
          type="warning"
          plain
          @click="downloadSample"
          >{{ $t("hzmbChange.message.view_sample") }}</el-button
        >
        <el-upload
          v-if="
            documentType.changeDocumentConfig &&
            documentType.changeDocumentConfig.showUploadDocumentBtn
          "
          class="upload-demo"
          ref="upload"
          action
          :on-change="handleChange"
          :file-list="fileList"
          :auto-upload="false"
          :show-file-list="false"
          :accept="documentType.fileExtensions"
          :disabled="loading"
        >
          <el-button
            slot="trigger"
            size="small"
            type="primary"
            :loading="loading"
            >{{
              fileList.length > 0
                ? $t("hzmbChange.message.reupload")
                : $t("hzmbChange.message.select_file")
            }}</el-button
          >
        </el-upload>
      </div>
    </div>
    <slot name="after"></slot>
    <pdfview
      v-if="showPdfView"
      :show="showPdfView"
      @close="showPdfView = false"
      :fileUrl="fileUrl"
      :fileType="extname"
    ></pdfview>
  </div>
</template>

<script>
import { resourcePath } from "@/api/axios";
import pdfview from "@/components/PdfView.vue";
import { fileExt, fsLimit } from "@/filters";
import HzmbVehDriApplicationChangeAPI from "@/api/HzmbVehDriApplicationChangeAPI";
import { downloadFile } from "@/util/util";
export default {
  components: { pdfview },
  props: {
    title: String,
    documentType: Object,
    application: Object,
  },
  data() {
    return {
      resourcePath: resourcePath,
      fileList: [],
      showPdfView: false,
      fileUrl: "",
      loading: false,
      downloadLoading: false,
    };
  },
  computed: {
    extname() {
      const filename =
        (this.documentType.sample && this.documentType.sample.filename) || null;
      if (!filename || typeof filename != "string") {
        return "";
      }
      let a = filename.split("").reverse().join("");
      let b = a.substring(0, a.search(/\./)).split("").reverse().join("");
      return b;
    },
  },
  methods: {
    handleChange(file, fileList) {
      const { fileExtensions, maxFileSize } = this.documentType;
      // 驗證文件格式
      if (!fileExt(file.name, fileExtensions)) {
        this.$message({
          type: "warning",
          message: `${this.$t("hzmbChange.message.upload_extensions_tips", [
            fileExtensions,
          ])}`,
        });
        return;
      }
      // 驗證文件大小限制
      if (!fsLimit(file.size, maxFileSize)) {
        this.$message({
          message: `${this.$t("hzmbChange.message.upload_maxSize_tips", [
            maxFileSize,
          ])}`,
          type: "error",
        });
        return;
      }
      // 處理拍照上傳文件名重複
      if (file.name == "image.jpg") {
        file.name = `image${new Date().getTime()}.jpg`;
      }

      this.doUpload(file, fileList);
    },
    async doUpload(file, fileList) {
      let val = this.documentType;
      const fileValue = {
        fileDescription: val.descriptionTc,
        fileTitle: val.nameTc,
        fileType: val.id,
      };
      try {
        this.loading = true;
        let appId = this.application.id;
        const serviceType = this.$store.state.serviceType;
        let document = await HzmbVehDriApplicationChangeAPI.saveFile(
          serviceType,
          appId,
          file.raw,
          fileValue
        );
        val.document = document;
        this.fileList = [fileList[fileList.length - 1]];
        this.$emit("change", this.fileList[0]);
      } catch (error) {
        this.loading = false;
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    removeFile() {
      this.$confirm(
        this.$t("message.confirm_delete"),
        this.$t("message.tips"),
        {
          confirmButtonText: this.$t("message.confirm"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              const serviceType = this.$store.state.serviceType;
              instance.confirmButtonLoading = true;
              HzmbVehDriApplicationChangeAPI.delFile(
                serviceType,
                this.application.id,
                this.documentType.document && this.documentType.document.id
              )
                .then(() => {
                  this.fileList = [];
                  this.$emit("removeFile");
                  done();
                  setTimeout(() => {
                    instance.confirmButtonLoading = false;
                  }, 300);
                })
                .catch((err) => {
                  this.$error(err);
                  done();
                  setTimeout(() => {
                    instance.confirmButtonLoading = false;
                  }, 300);
                });
            } else {
              done();
            }
          },
        }
      );
    },
    // 下載動態文件
    async downloadDynamic() {
      try {
        this.downloadLoading = true;
        const res = await HzmbVehDriApplicationChangeAPI.dynamicDownload(
          this.application.id,
          this.documentType.id
        );
        downloadFile(res);
      } catch (error) {
        this.$error(error);
      } finally {
        this.downloadLoading = false;
      }
    },
    // 下載樣本文件
    downloadSample() {
      if (this.$store.state.isMobile) {
        this.fileUrl = `${
          this.resourcePath
        }/public/api/v1/document-type/download/${this.documentType.id}${
          this.extname ? `.${this.extname}` : ""
        }`;
        this.showPdfView = true;
      } else {
        window.open(
          `${this.resourcePath}/public/api/v1/document-type/download/${
            this.documentType.id
          }${this.extname ? `.${this.extname}` : ""}`
        );
      }
    },
  },
  created() {
    if (this.documentType.file) {
      this.fileList = [{ ...this.documentType.file }];
    }
  },
};
</script>

<style lang="scss" scoped>
.upload_list {
  border-bottom: 1px solid rgba(50, 50, 50, 0.16);
}
.upload_list_title {
  font-size: 18px;
  line-height: 25px;
  margin: 15px 0;
  color: #1c1c1c;
  font-weight: bold;
}
.upload_list_title_required:after {
  content: "*";
  color: #f56c6c;
  margin-left: 4px;
}
.upload_list_tips {
  background: rgba(162, 214, 255, 0.13);
  border-radius: 4px;
  padding: 12px 14px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(144, 144, 144, 1);
  line-height: 22px;
}
.upload_list_file {
  padding: 16px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.upload_list_file_text {
  font-size: 16px;
  line-height: 22px;
  min-width: 100px;
}
.upload_list_fileName {
  font-size: 16px;
  line-height: 22px;
  color: #38959d;
  word-break: break-all;
}
.upload_del {
  color: #f40101;
  margin-left: 5px;
  cursor: pointer;
}
.upload_filename {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
/deep/.view_sample_danger {
  background: #fff !important;
  border-color: #f55159 !important;
  color: #f55159 !important;
  min-width: 98px;
}
/deep/.view_sample_danger:hover {
  background: #f55159 !important;
  border-color: #f55159 !important;
  color: #fff !important;
}

@media screen and (max-width: 767px) {
  .upload_list_file {
    flex-direction: column;
    align-items: flex-start;
    .pub_btn {
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>
